module.exports = __webpack_public_path__ + "static/img/数据安全icon.9c314977.svg";